import {gql} from "@apollo/client";

export const GET_ACTIVE_DEPOSIT_LIMITS = gql`
          query GetActiveDepositLimits {
                   limits (where: { and: [
                     {status :{ eq : ACTIVE}}
                     {type :{ eq : DEPOSIT}}
                   ]}) {
                     nodes {
                       id
                       period
                       value
                       currentAmount
                     }
                   }
                 
          }`;
